// 将数组分成多个子数组
export function splitGroups<T>(list: Array<T>, lenPerGroup: number): Array<T[]> {
    const groups = new Array(Math.ceil(list.length / lenPerGroup));
    list.forEach((item, index) => {
        const slideIndex = Math.floor(index / lenPerGroup);
        if (!groups[slideIndex]) {
            groups[slideIndex] = [];
        }
        groups[slideIndex][index % lenPerGroup] = item;

    });
    return groups;
}

// 计算数字数组的和
export function sum(arr: number[]): number {
    return arr.reduce((total, cur) => total + cur);
}

